// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colorscalePickerContainer {
  max-height: 550px;
  max-width: 700px;
  min-width: 295px;
  overflow-y: auto;
  overflow-x: hidden;
  background: rgba(242, 245, 250, 0.9);
  border: 1px solid #c8d4e3;
  position: absolute;
  z-index: 99;
  font-family: Helvetica, sans-serif;
  padding: 10px;
  resize: horizontal;
  text-align: left;
}

.colorscalePickerContainer::-webkit-scrollbar {
  width: 5px;
  background-color: #dfe8f3;
}

.colorscalePickerContainer::-webkit-scrollbar-thumb {
  background-color: #a2b1c6;
}

.colorscalePickerContainer::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.3);
  background-color: #dfe8f3;
}

.colorscalePickerContainer .textLabel {
  color: rgb(80, 103, 132);
  font-size: 12px;
  vertical-align: top;
  font-weight: 600;
  text-transform: uppercase;
}

.colorscalePickerContainer .spaceRight {
  margin-right: 5px;
}
.colorscalePickerContainer .spaceRightZeroTop {
  margin-right: 5px;
  margin-top: 0;
}
.colorscalePickerContainer .spaceLeft {
  margin-left: 5px;
}
.colorscalePickerContainer .spaceTop {
  margin-top: 5px;
}
.colorscalePickerContainer .alignMiddle {
  vertical-align: middle;
}
.colorscalePickerContainer .alignTop {
  vertical-align: top;
}
.colorscalePickerContainer .zeroSpace {
  margin: 0;
}
.colorscalePickerContainer .noWrap {
  white-space: nowrap;
}
.colorscalePickerContainer .inlineBlock {
  display: inline-block;
}

.colorscalePickerBottomContainer {
  padding: 10px 0;
}

.colorscaleDescription {
  font-size: 13px;
  color: #506784;
  border: 1px solid #c8d4e3;
  padding: 10px;
  border-radius: 2px;
  text-align: left;
  line-height: 1.4em;
}

.colorscaleControlPanel {
  display: block;
  padding: 10px;
  width: 80%;
  margin: 0 auto;
}

.colorscalePickerContainer input[type="range"] {
  width: 200px;
}

.colorscalePickerContainer input[type="number"] {
  vertical-align: top;
  margin-top: -4px;
  margin-right: 5px;
}

.colorscalePickerContainer input[type="text"] {
  text-align: center;
  font-size: 12px;
  width: 90%;
  margin-top: 5px;
  padding: 5px;
  border: 1px solid #dfe8f3;
}

.colorscaleControlsRow {
  margin-top: 20px;
}

.colorscaleControlsRow div {
  display: inline;
}

.colorscaleControlPanel .rc-slider-tooltip {
  opacity: 1;
  z-index: 999;
  font-family: Helvetica, sans-serif;
}

.colorscaleControlPanel .rc-slider-rail {
  background-color: #a2b1c6;
}

.Select.is-focused:not(.is-open) > .Select-control {
  border-color: #c8d4e3 !important;
  box-shadow: none;
}

.colorscaleLabel {
    font-weight: 600;
    font-size: 12px;
    color: #2a3f5f;
    display: inline-block;
    width: 25%;
    text-align: start;
    padding: 10px;
}

.colorscale-block {
    padding: 10px 0px;
}

.colorscale-block, .colorscaleLabel {
    padding-right: 5px;
    padding-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/lib/react-colorscales/ColorscalePicker.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,UAAU;IACV,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB","sourcesContent":[".colorscalePickerContainer {\n  max-height: 550px;\n  max-width: 700px;\n  min-width: 295px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: rgba(242, 245, 250, 0.9);\n  border: 1px solid #c8d4e3;\n  position: absolute;\n  z-index: 99;\n  font-family: Helvetica, sans-serif;\n  padding: 10px;\n  resize: horizontal;\n  text-align: left;\n}\n\n.colorscalePickerContainer::-webkit-scrollbar {\n  width: 5px;\n  background-color: #dfe8f3;\n}\n\n.colorscalePickerContainer::-webkit-scrollbar-thumb {\n  background-color: #a2b1c6;\n}\n\n.colorscalePickerContainer::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.3);\n  background-color: #dfe8f3;\n}\n\n.colorscalePickerContainer .textLabel {\n  color: rgb(80, 103, 132);\n  font-size: 12px;\n  vertical-align: top;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.colorscalePickerContainer .spaceRight {\n  margin-right: 5px;\n}\n.colorscalePickerContainer .spaceRightZeroTop {\n  margin-right: 5px;\n  margin-top: 0;\n}\n.colorscalePickerContainer .spaceLeft {\n  margin-left: 5px;\n}\n.colorscalePickerContainer .spaceTop {\n  margin-top: 5px;\n}\n.colorscalePickerContainer .alignMiddle {\n  vertical-align: middle;\n}\n.colorscalePickerContainer .alignTop {\n  vertical-align: top;\n}\n.colorscalePickerContainer .zeroSpace {\n  margin: 0;\n}\n.colorscalePickerContainer .noWrap {\n  white-space: nowrap;\n}\n.colorscalePickerContainer .inlineBlock {\n  display: inline-block;\n}\n\n.colorscalePickerBottomContainer {\n  padding: 10px 0;\n}\n\n.colorscaleDescription {\n  font-size: 13px;\n  color: #506784;\n  border: 1px solid #c8d4e3;\n  padding: 10px;\n  border-radius: 2px;\n  text-align: left;\n  line-height: 1.4em;\n}\n\n.colorscaleControlPanel {\n  display: block;\n  padding: 10px;\n  width: 80%;\n  margin: 0 auto;\n}\n\n.colorscalePickerContainer input[type=\"range\"] {\n  width: 200px;\n}\n\n.colorscalePickerContainer input[type=\"number\"] {\n  vertical-align: top;\n  margin-top: -4px;\n  margin-right: 5px;\n}\n\n.colorscalePickerContainer input[type=\"text\"] {\n  text-align: center;\n  font-size: 12px;\n  width: 90%;\n  margin-top: 5px;\n  padding: 5px;\n  border: 1px solid #dfe8f3;\n}\n\n.colorscaleControlsRow {\n  margin-top: 20px;\n}\n\n.colorscaleControlsRow div {\n  display: inline;\n}\n\n.colorscaleControlPanel .rc-slider-tooltip {\n  opacity: 1;\n  z-index: 999;\n  font-family: Helvetica, sans-serif;\n}\n\n.colorscaleControlPanel .rc-slider-rail {\n  background-color: #a2b1c6;\n}\n\n.Select.is-focused:not(.is-open) > .Select-control {\n  border-color: #c8d4e3 !important;\n  box-shadow: none;\n}\n\n.colorscaleLabel {\n    font-weight: 600;\n    font-size: 12px;\n    color: #2a3f5f;\n    display: inline-block;\n    width: 25%;\n    text-align: start;\n    padding: 10px;\n}\n\n.colorscale-block {\n    padding: 10px 0px;\n}\n\n.colorscale-block, .colorscaleLabel {\n    padding-right: 5px;\n    padding-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
